var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAlertRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79228 1.63819L1.17767 11.0114C1.0619 11.2118 1.00065 11.4391 1.00001 11.6706C0.999357 11.9021 1.05933 12.1297 1.17397 12.3308C1.28861 12.532 1.45391 12.6995 1.65342 12.8169C1.85294 12.9343 2.07972 12.9975 2.31119 13H13.5404C13.7719 12.9975 13.9987 12.9343 14.1982 12.8169C14.3977 12.6995 14.563 12.532 14.6777 12.3308C14.7923 12.1297 14.8523 11.9021 14.8516 11.6706C14.851 11.4391 14.7897 11.2118 14.674 11.0114L9.05934 1.63819C8.94117 1.44337 8.77478 1.2823 8.57623 1.17051C8.37768 1.05873 8.15367 1 7.92581 1C7.69796 1 7.47395 1.05873 7.2754 1.17051C7.07684 1.2823 6.91046 1.44337 6.79228 1.63819Z",
    stroke: "#FF2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92581 5.04553V7.69706",
    stroke: "#FF2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92581 10.3484H7.93465",
    stroke: "#FF2D2D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertRed);
export default __webpack_public_path__ + "static/media/icon-alert-red.47d2a90a1db364c5559ba2ddb00de564.svg";
export { ForwardRef as ReactComponent };